import { Box, Chip, Paper, Stack, Typography } from '@mui/material';
import Section from './Section';
import { skills } from '../../data/profile';

export default function Skills() {
    return (
        <Section id="habilidades" eyebrow="Stack técnico" title="Habilidades" muted>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
                {skills.map((s) => (
                    <Paper key={s.group} variant="outlined" sx={{ p: 3 }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{s.group}</Typography>
                        <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 1 }}>
                            {s.items.map((it) => <Chip key={it} label={it} variant="outlined" />)}
                        </Stack>
                    </Paper>
                ))}
            </Box>
        </Section>
    );
}
